import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'taboola-ultimate-ui';
import { TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { DEFAULT_PAGE } from 'components/AppBreadcrumbs/components/BreadcrumbsDropdown/pickerConstatns';
import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { useNavigate } from 'hooks';
import { CAMPAIGNS_ROUTE } from 'modules/campaigns/config';
import { REPORT_ENTITY_IDS } from 'modules/campaigns/hooks/useReportEntityIds';
import { REPORT_ENTITY_TYPE } from 'modules/campaigns/hooks/useReportEntityType';
import { CREATIVE_REPORT_ID } from 'modules/campaigns/modules/campaigns-reports/config/reports/creative/creativeReportId';
import { REPORT_ID, REPORT_PAGE } from 'modules/campaigns/modules/campaigns-reports/hooks';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { mergeQueryParamsWithLocation } from 'modules/taboola-common-frontend-modules/query-params';
import EllipsisCellRenderer from './EllipsisCellRenderer';
import styles from './assignmentCellRenderer.module.scss';

const TooltipContent = ({ adGroups, onCampaignClick }) => {
    if (!adGroups?.length) {
        return (
            <FormattedMessage
                id="app.campaigns.reports.grid.column.content.adGroups.empty"
                defaultMessage="No campaigns assigned"
            />
        );
    }
    return (
        <div>
            <FormattedMessage
                id="app.campaigns.reports.grid.column.content.adGroups.title"
                defaultMessage="Assigned campaigns:"
            />
            <br />
            {adGroups.map(adGroup => (
                <div key={adGroup.campaignId}>
                    <Button onClick={() => onCampaignClick(adGroup.campaignId)} className={styles['campaign-link']}>
                        {adGroup.campaignId}
                    </Button>
                </div>
            ))}
        </div>
    );
};

export const AssignmentCellRenderer = ({ data = {}, ...rest }) => {
    const { adGroups } = data;
    const navigate = useNavigate();

    const handleCampaignClick = useCallback(
        campaignId => {
            const campaignPath = mergeQueryParamsWithLocation(
                { pathname: CAMPAIGNS_ROUTE },
                {
                    [REPORT_ID]: CREATIVE_REPORT_ID,
                    [REPORT_PAGE]: DEFAULT_PAGE,
                    [REPORT_ENTITY_TYPE]: 'CAMPAIGN',
                    [REPORT_ENTITY_IDS]: campaignId,
                }
            );
            navigate(campaignPath);
        },
        [navigate]
    );

    const tooltipContent = TooltipContent({ adGroups, onCampaignClick: handleCampaignClick });

    return (
        <TooltipWrapper
            tooltipContent={tooltipContent}
            tooltipOptions={{
                arrow: true,
                interactive: true,
                position: TOOLTIP_POSITION.TOP,
            }}
        >
            <EllipsisCellRenderer {...rest} />
        </TooltipWrapper>
    );
};

AssignmentCellRenderer.propTypes = {
    data: PropTypes.shape({
        adGroups: PropTypes.arrayOf(
            PropTypes.shape({
                campaignId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            })
        ),
    }),
};
